import React from 'react'
import classnames from 'classnames'
import '../../assets/styles/components/tips.scss'
import { connect } from 'react-redux';
import wrong_icon from '@/assets/images/icons/wrong_icon.png'
import success_icon from '@/assets/images/icons/icon_success.png'
import warning_icon from '@/assets/images/icons/icon_warning.png'
import { tipsType } from '@/constants/tips-type';
class Tips extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  switchImg(type){
    let img = ''
    switch (type) {
      case tipsType.success:
        img = success_icon;
        break;
      case tipsType.error:
        img = wrong_icon;
        break;
      case tipsType.warning:
        img = warning_icon;
        break;
      default:
        img = wrong_icon;
        break;
    }
    return img;
  }

  render() {
    const { isNoBgColor, style, showIcon, type } = this.props;
    return (
      <div style={style} className={classnames("tips-text", `${type}-text`, isNoBgColor && "non-bg-color")}>
        {
          showIcon && <label>
            <img src={this.switchImg(type)} alt="wrong_icon" />
          </label>
        }
        <span>
          {this.props.children}
        </span>
      </div>
    )
  }
}

Tips.defaultProps = {
  isNoBgColor: false,
  type: tipsType.error, //info success warning
  showIcon: true,
  style: {}
}

export default connect(
)(Tips)